import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralFormController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-form.controller';

@Injectable()
export class CoachSettingsGeneralDiplomaController {
	public baseI18n =
		'presentation.app.page.settings.coach.general.references.diplomas';

	public calendarLocale$: Observable<any>;

	constructor(
		private _translateService: TranslateService,
		private _formController: CoachSettingsGeneralFormController
	) {
		this._initObservables();
	}

	private _initObservables() {
		this.calendarLocale$ = this._translateService.stream(
			'presentation.primeng.calendar'
		);
	}

	public removeDiploma(index: number, form: FormGroup) {
		const diplomasArray = form.get('diplomas') as FormArray;
		diplomasArray.removeAt(index);
	}

	public addDiploma(form: FormGroup) {
		const diplomasArray = form.get('diplomas') as FormArray;
		diplomasArray.push(
			this._formController.addReferenceGroup(form.get('newDiploma'))
		);
	}
}
